
// 给每个a链接新添加一个class commercial_link_hyt，用于此次append置顶入口布点dom时判断当前页面是否已经有了置顶布点的dom，如果已经有了则不再append，否则则append


var issueDom = {
		"7": `<a class="commercial_link commercial_link_hyt" href="javascript:void(0)" data-href="dataLink">isTypeText</a>`,
		"20": `<a target="_blank" class="commercial_link_hyt" href="dataLink">isTypeText</a>`,
		15: `<div class="commercial_vip" style="height:66px;"><p class="commercial_empty"></p><h3 class="commercial_vip_title">置顶</h3><p class="commercial_vip_tips">置顶展示在页面最顶部</p><span data-href="dataLink" class="commercial_vip_top commercial_link commercial_link_hyt">isTypeText</span></div>`,
		1: `<span><a class="commercial_link commercial_link_hyt" href="javascript:void(0)" data-href="dataLink">isTypeText</a></span>`,
		0: `<span><a class="commercial_link commercial_link_hyt" href="javascript:void(0)" data-href="dataLink">isTypeText</a></span>`,
		6:  `<em class="qtlist_status2"><a class="commercial_link commercial_link_hyt" href="javascript:void(0)" data-href="dataLink">isTypeText</a></em>`,
		"26":  `<div class="commercial_vip"><p class="commercial_empty"></p><h3 class="commercial_vip_title">置顶</h3><p class="commercial_vip_tips">置顶展示在页面最顶部</p><span data-href="dataLink" class="commercial_vip_top commercial_link commercial_link_hyt">isTypeText</span></div>`
	}

export default function(commonType,isType,link){
    var type = ",21,22,25,".indexOf(','+commonType+',') > -1?26:commonType;
    var manege = isType ? (',1,0,6,'.indexOf(','+commonType+',')>-1?'置顶管理':'管理'): '置顶';
	return issueDom[type].replace("dataLink",link).replace("isTypeText",manege);
}